import React from 'react';
import SiteHeader from '../../shared/SiteHeader';

const Study: React.FC = () => {
  return (
    <>
      <SiteHeader />
      <main className="container py-4">
        <h1 className="h3 mb-3">Study</h1>
        <p className="text-muted">
          This area will provide study tools and resources in a future update.
        </p>
      </main>
    </>
  );
};

export default Study;
